import React, { useEffect, useRef } from 'react';

const DrawPath = ({ coordinates, imageWidth, imageHeight }) => {
    const svgRef = useRef(null);

    useEffect(() => {
        const svg = svgRef.current;

        // Remove existing polyline, square, and circle elements
        const existingPolyline = svg.querySelector('polyline');
        if (existingPolyline) {
            existingPolyline.remove();
        }

        const existingSquare = svg.querySelector('rect');
        if (existingSquare) {
            existingSquare.remove();
        }

        const existingCircle = svg.querySelector('circle');
        if (existingCircle) {
            existingCircle.remove();
        }

        // Define the image dimensions and scale factors
        const scaleX = imageWidth;
        const scaleY = imageHeight;

        const firstCoordinate = coordinates[0];
        const lastCoordinate = coordinates[coordinates.length - 1];

        // Draw polyline
        const points = coordinates.map(([x, y]) => `${x * scaleX},${y * scaleY}`).join(' ');
        const polylineElement = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        polylineElement.setAttribute('points', points);
        polylineElement.setAttribute('fill', 'none');
        polylineElement.setAttribute('stroke', 'red');
        polylineElement.setAttribute('stroke-width', '1');
        svg.appendChild(polylineElement);

        // Draw square at the first coordinate
        const srcElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        srcElement.setAttribute('x', (firstCoordinate[0] * scaleX) - 4);
        srcElement.setAttribute('y', (firstCoordinate[1] * scaleY) - 4);
        srcElement.setAttribute('width', '8');
        srcElement.setAttribute('height', '8');
        srcElement.setAttribute('fill', 'green');
        svg.appendChild(srcElement);

        // Draw circle at the last coordinate
        const dstElement = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dstElement.setAttribute('cx', lastCoordinate[0] * scaleX);
        dstElement.setAttribute('cy', lastCoordinate[1] * scaleY);
        dstElement.setAttribute('r', '3');
        dstElement.setAttribute('fill', 'yellow');
        svg.appendChild(dstElement);

    }, [coordinates, imageWidth, imageHeight]);

    return (
        <svg ref={svgRef} style={{
            position: 'absolute', zIndex: 2, width: imageWidth,
            height: imageHeight
        }} display="flex" justifyContent="center" alignItems="center"></svg>
    );
};

export default DrawPath;
